module.exports = __webpack_public_path__ + "static/media/A18040103_10003_3.9565cf3d.jpg";